export default __webpack_public_path__ + "static/media/Icon-material-person-bw.b14748a1.svg";